import CommonConstants from '@/common/CommonConstants'
import { nextTick } from 'process'
import { Component, Vue } from 'vue-property-decorator'
import CAAG1050Service from './CAAG1050Service'
import CAAG1050ViewModel from './CAAG1050ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import { FormatConstants } from '@/common/FormatConstants'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import CommonUtil from '@/common/utils/CommonUtil'
@Component({
  name: 'CAAG1050',
  components: {}
  })
export default class CAAG1050Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private FormatConstants = FormatConstants
  private isDisPlayContent = false
  private caag1050Service = new CAAG1050Service()
  private caag1050ViewModel: CAAG1050ViewModel = {
    newsDtlLgnBeforeInfo: {
      titl: '',
      information: '',
      postDay: '',
      report1Name: '',
      report1Url: '',
      report2Name: '',
      report2Url: '',
      report3Name: '',
      report3Url: ''
    }
  }

  /**
   * 画面要素描画後処理
   */
  mounted() {
    nextTick(() => {
      fixedContentNoLogin()
    })
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const id = Number(JSON.parse(JSON.stringify(this.$route.query.id || '')))
    const caaa1050ResponseModel = await this.caag1050Service.callAPICAAA1050(id)

    if (CommonUtil.isNotEmpty(caaa1050ResponseModel.newsDtlLgnBeforeInfo)) {
      this.isDisPlayContent = true
      this.caag1050ViewModel.newsDtlLgnBeforeInfo =
        caaa1050ResponseModel.newsDtlLgnBeforeInfo
      this.caag1050ViewModel.newsDtlLgnBeforeInfo.information =
        this.caag1050ViewModel.newsDtlLgnBeforeInfo?.information?.replaceAll(
          CommonConstants.REGEX_LINE_BREAK,
          '<br/>'
        )
    }
  }

  /**
   * PDFファイルを別タブで開く。
   * @param pdfFilePath
   */
  private async openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }

  /**
   * 「お知らせ一覧」（CAAG1040）画面に遷移する。
   */
  private gotoCAAG1040() {
    this.$router.push({ name: 'caag1040', params: {} })
  }
}
